export default __webpack_public_path__ + "static/media/a-token-of-security.2d856972.jpg";